import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { appUpdater } from './core/pwa/update.js'
import { App } from './ui/App.js'
import './ui/tokens.css'
import './ui/app.css'

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
void import('virtual:pwa-register').then(({ registerSW }) => {
  appUpdater.register(({ onNeedRefresh, onOfflineReady }) => registerSW({
    immediate: true,
    onNeedRefresh,
    onOfflineReady
  }))
})
